// actions.js
import { constants } from "../constants/redux-constants";

export const showLoader = () => ({
  type: constants.SHOW_LOADER,
});

export const hideLoader = () => ({
  type: constants.HIDE_LOADER,
});

export const progressStatus = (payload) => ({
  type: constants.PROGRESS_STATUS,
  payload,
});
